/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import React from "react";
import CustomTooltip from "../../../../../../../../components/CustomTooltip";
import {IconDepartment} from "../../../../../../../../components/buttons/IconButtons";
import {EMPTY_VALUES} from "../../../../../../../../Apis/functions";

/**
 * Departments responsible for the movement.
 *
 * A movement is answered by as many departments as it was registered with, so
 * the list is read in pairs and grows with the departments the folio has; a
 * folio registered without any of them keeps the row with the empty value.
 *
 * @param {Function} t - Translation function.
 * @param {Array<string>} departments - Names of the responsible departments.
 *
 * @returns {JSX.Element} Section of the responsible departments.
 */
const DepartmentsSection = ({t, departments = []}) => {
    const list = departments?.length > 0 ? departments : [EMPTY_VALUES.DEFAULT];

    return (
        <div className={'col-12 px-0'}>
            <p className='font-color-general-950 fs-14px ibl-font-w-600 px-0 mb-1'>
                {t('responsible_departments')}
            </p>

            <div className={'row mx-0 p-0'}>
                {list.map((department, index) => (
                    <div
                        key={`${index}-${department}`}
                        className={'col-6 px-0 pr-3 mb-1 d-flex align-items-center minw-0'}
                    >
                        <div className={'mr-2 d-flex align-items-center'}>
                            <IconDepartment/>
                        </div>
                        <div className={'flex-grow-1 minw-0'}>
                            <CustomTooltip
                                text={department}
                                classes={'fs-14px font-color-general-950 text-ellipsis-1-row align-items-center'}
                                showIfTruncated={true}
                            />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DepartmentsSection;
